import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../common/models';

export class AllocationViewActionQuestionModel {
  id: number;
  pass: boolean;
  text: string;
}

export class AllocationViewActionQuestionForm {
  constructor(
    model: AllocationViewActionQuestionModel,
    public id: ControlProperty<number> = [model.id, []],
    public text: ControlProperty<string> = [model.text, []],
    public pass: ControlProperty<boolean> = [model.pass, [Validators.required]],
  ) {}
}
